import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEquipmentLabelPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.04 22.39L15.052 22.397C16.1141 23.0732 17.3751 23.3669 18.6267 23.2297C19.8784 23.0924 21.0457 22.5323 21.936 21.642L22.71 20.868C23.0557 20.5219 23.2499 20.0527 23.2499 19.5635C23.2499 19.0743 23.0557 18.6051 22.71 18.259L19.449 15C19.1029 14.6543 18.6337 14.4601 18.1445 14.4601C17.6553 14.4601 17.1861 14.6543 16.84 15V15C16.6689 15.1714 16.4656 15.3073 16.2418 15.4001C16.0181 15.4929 15.7782 15.5406 15.536 15.5406C15.2938 15.5406 15.054 15.4929 14.8302 15.4001C14.6065 15.3073 14.4032 15.1714 14.232 15L9.01402 9.78099C8.66833 9.43487 8.47416 8.96568 8.47416 8.47649C8.47416 7.98731 8.66833 7.51812 9.01402 7.17199V7.17199C9.1854 7.00083 9.32136 6.79755 9.41412 6.5738C9.50688 6.35005 9.55463 6.11021 9.55463 5.86799C9.55463 5.62578 9.50688 5.38594 9.41412 5.16218C9.32136 4.93843 9.1854 4.73516 9.01402 4.56399L5.75402 1.29999C5.4079 0.954303 4.93871 0.760132 4.44952 0.760132C3.96033 0.760132 3.49115 0.954303 3.14502 1.29999L2.37102 2.07399C1.48085 2.96437 0.920833 4.13164 0.783392 5.38315C0.645951 6.63467 0.939297 7.89565 1.61502 8.95799L1.62302 8.96999C5.19643 14.2598 9.751 18.8154 15.04 22.39V22.39Z",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEquipmentLabelPhone;
